export default "__VITE_ASSET__9pgUL3EC__"